import { logger } from 'functions/logger/logger'
import { WS } from './websocket'

export const createSocket = (
  socket: any,
  doMessage: any,
  setStatus: any,
  WS_URL: string,
  name: string,
  wsbridge?: string,
) => {
  const hostname = window.location.hostname
  logger.log({ WS_URL, hostname, wsbridge }, 'init')
  // WS_URL = `wss://${window.location.host}/websocketbridge/ws/` + name
  // wsbridge/v1/game  golang wsbridge
  // websocketbridge/ws java wsbridge
  if (hostname === 'localhost') {
    WS_URL = `wss://dev.orbitalgaming.io/${wsbridge}/${name}`
    logger.log({ WS_URL, hostname, wsbridge }, 'localhist')
  } else if (WS_URL === '{{SERVER_WS_URL}}') {
    WS_URL = `wss://${hostname}/${wsbridge}/${name}`
    logger.log({ WS_URL, hostname, wsbridge }, 'ws server url')
  }
  if (WS_URL.includes('orbitalgaming.com')) {
    console.clear()
    logger.isEnabled = false
  }
  socket.current = new WS()
    .Init({
      WS_URL: WS_URL,
      doMessage: doMessage,
      setStatus: setStatus,
    })
    .Start()
}
